import {
    GET_ANT,
    GET_ANTECEDENTES,
    GET_CARGOS_EMPRESARIALES,
    GET_BIENESINMUEBLES,
    GET_CEDULACORRECTA,
    GET_CEDULACOUNT,
    GET_CEDULAINCORREC,
    GET_CREATECEDULA,
    GET_DELETECEDULA,
    GET_DEMANDAOFENDIDO,
    GET_DEMANDAOFENSOR,
    GET_DENUNCIAS,
    GET_DIRECCIONES,
    GET_EMAIL,
    GET_ERROR_ANT,
    GET_ERROR_LISTAS_NEGRAS,
    GET_ERROR_ANTECEDENTES,
    GET_ERROR_CARGOS_EMPRESARIALES,
    GET_ERROR_BIENESINMUEBLES,
    GET_ERROR_CEDULA,
    GET_ERROR_CEDULACOUNT,
    GET_ERROR_CREATECEDULA,
    GET_ERROR_DELETECEDULA,
    GET_ERROR_DEMANDAOFENDIDO,
    GET_ERROR_DEMANDAOFENSOR,
    GET_ERROR_DENUNCIAS,
    GET_ERROR_DIRECCIONES,
    GET_ERROR_EMAIL,
    GET_ERROR_HIJOS,
    GET_ERROR_INFNOMBRE,
    GET_ERROR_INVERSIONES,
    GET_ERROR_LABORALHISTORICO,
    GET_ERROR_LICENCIA,
    GET_ERROR_LISTACONTROL,
    GET_ERROR_MECANIZADO,
    GET_ERROR_MECANIZADOGRAFICO,
    GET_ERROR_COGNODATA,
    GET_ERROR_PADRES,
    GET_ERROR_PERSONINFO,
    GET_ERROR_SUPA,
    GET_ERROR_TELEFONOS,
    GET_ERROR_TITULOS,
    GET_ERROR_VEHICULO,
    GET_HIJOS,
    GET_INFNOMBRE,
    GET_INVERSIONES,
    GET_LABORALHISTORICO,
    GET_LICENCIA,
    GET_LISTACONTROL,
    GET_MECANIZADO,
    GET_MECANIZADOGRAFICO,
    GET_COGNODATA,
    GET_PADRES,
    GET_PERSONINFO,
    GET_SUPA,
    GET_TELEFONOS,
    GET_TITULOS,
    GET_VEHICULO,
    GET_LISTAS_NEGRAS,
    LOADING_ANT,
    LOADING_ANTECEDENTES,
    LOADING_CARGOS_EMPRESARIALES,
    LOADING_BIENESINMUEBLES,
    LOADING_CEDULA,
    LOADING_CEDULACOUNT,
    LOADING_CREATECEDULA,
    LOADING_DELETECEDULA,
    LOADING_DEMANDAOFENDIDO,
    LOADING_DEMANDAOFENSOR,
    LOADING_DENUNCIAS,
    LOADING_DIRECCIONES,
    LOADING_EMAIL,
    LOADING_HIJOS,
    LOADING_INFNOMBRE,
    LOADING_INVERSIONES,
    LOADING_LABORALHISTORICO,
    LOADING_LICENCIA,
    LOADING_LISTACONTROL,
    LOADING_MECANIZADO,
    LOADING_MECANIZADOGRAFICO,
    LOADING_COGNODATA,
    LOADING_PADRES,
    LOADING_PERSONINFO,
    LOADING_SUPA,
    LOADING_TELEFONOS,
    LOADING_TITULOS,
    LOADING_VEHICULO,
    LOADING_LISTAS_NEGRAS,
    RESET_STATE_PERSON,
    RESET_SUCCESS,
    RESET_VALUE,
    SET_VALUE,
    GET_ERROR_COOPINFO,
    GET_COOPINFO,
    LOADING_COOPINFO,
    GET_DINERSINFO,
    LOADING_DINERSINFO,
    GET_ERROR_DINERSINFO,
    GET_SUPERINFO,
    LOADING_SUPERINFO,
    GET_ERROR_SUPERINFO,
    GET_ERROR_VACUNAINFO,
    GET_VACUNAINFO,
    LOADING_VACUNAINFO,
    GET_ERROR_ESTABLECIMIENTOINFO,
    GET_ESTABLECIMIENTOINFO,
    LOADING_ESTABLECIMIENTOINFO,
    GET_ERROR_CONTRIBUYENTEINFO,
    GET_CONTRIBUYENTEINFO,
    LOADING_CONTRIBUYENTEINFO,
    GET_CONTRIBUYENTE_IMPUESTOS,
    LOADING_CONTRIBUYENTE_IMPUESTOS,
    GET_ERROR_CONTRIBUYENTE_IMPUESTOS,
    LOADING_REDIRECT_URL,
    GET_REDIRECT_URL,
    GET_ERROR_REDIRECT_URL,
    GET_EMPRESA_REALM,
    LOADING_EMPRESA_REALM,
    GET_ERROR_EMPRESA_REALM,
    RESET_REDIRECT_URL,
    GET_AFILIACION_ISSPOL,
    LOADING_AFILIACION_ISSPOL,
    GET_ERROR_AFILIACION_ISSPOL,
    GET_PERSONA_PENSIONISTA,
    LOADING_PERSONA_PENSIONISTA,
    GET_ERROR_PERSONA_PENSIONISTA,
    GET_AFILIACION_IESS,
    GET_AFILIACION_IESS_PDF,
    GET_AFILIACION_ISSPOL_PDF,
    GET_PENSIONISTA_PDF,
    LOADING_AFILIACION_IESS,
    LOADING_AFILIACION_IESS_PDF,
    LOADING_AFILIACION_ISSPOL_PDF,
    LOADING_PENSIONISTA_PDF,
    GET_ERROR_AFILIACION_IESS,
    GET_ERROR_AFILIACION_IESS_PDF,
    GET_ERROR_AFILIACION_ISSPOL_PDF,
    GET_ERROR_PENSIONISTA_PDF,
    GET_DEUDAS_AMT,
    LOADING_DEUDAS_AMT,
    LOADING_DEUDAS_EMOV,
    GET_ERROR_DEUDAS_EMOV,
    GET_DEUDAS_EMOV,
    GET_ERROR_DEUDAS_AMT,
    GET_LIST_OFAC,
    LOADING_LIST_OFAC,
    GET_ERROR_LIST_OFAC,
    GET_FILE_REQUEST,
    LOADING_FILE_REQUEST,
    GET_ERROR_FILE_REQUEST,
    LOADING_FILE_UPLOAD,
    GET_FILE_UPLOAD,
    GET_ERROR_FILE_UPLOAD,
    GET_DEMANDAS_BATCH,
    LOADING_DEMANDAS_BATCH,
    GET_ERROR_DEMANDAS_BATCH,
    GET_DOWNLOAD_ACTIVITY_REQUEST,
    LOADING_DOWNLOAD_ACTIVITY_REQUEST,
    GET_ERROR_DOWNLOAD_ACTIVITY_REQUEST,
    GET_DEMANDAS_BATCH_PROGRESS,
    LOADING_DEMANDAS_BATCH_PROGRESS,
    GET_ERROR_DEMANDAS_BATCH_PROGRESS,
    RESET_PROGRESS,
    RESET_FILE_REQUEST,
    RESET_DEMANDAS_BATCH,
    LOADING_AFILIACION_ISSFAC_MEDICO,
    GET_AFILIACION_ISSFAC_MEDICO,
    GET_ERROR_AFILIACION_ISSFAC_MEDICO,
    GET_AFILIACION_ISSFAC_FUERZA_ARMADA,
    LOADING_AFILIACION_ISSFAC_FUERZA_ARMADA,
    GET_ERROR_AFILIACION_ISSFAC_FUERZA_ARMADA,
    GET_AFILIACION_CUMPLIMIENTO_PATRONAL,
    LOADING_AFILIACION_CUMPLIMIENTO_PATRONAL,
    GET_ERROR_AFILIACION_CUMPLIMIENTO_PATRONAL,
    LOADING_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF,
    GET_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF,
    GET_ERROR_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF,
    GET_AFILIACION_SIISPOL,
    LOADING_AFILIACION_SIISPOL,
    GET_ERROR_AFILIACION_SIISPOL,
    GET_AFILIACION_SIISPOL_PDF,
    LOADING_AFILIACION_SIISPOL_PDF,
    GET_ERROR_AFILIACION_SIISPOL_PDF,
    GET_SININIESTROS,
    LOADING_SININIESTROS,
    GET_ERROR_SININIESTROS,
    GET_SUPERINTENDENCIA_DEUDORES,
    LOADING_SUPERINTENDENCIA_DEUDORES,
    GET_ERROR_SUPERINTENDENCIA_DEUDORES,
    GET_PERSONA_EMPLEADOS,
    LOADING_PERSONA_EMPLEADOS,
    GET_ERROR_PERSONA_EMPLEADOS,
    GET_CREDITO_QUIROGRAFARIO,
    LOADING_CREDITO_QUIROGRAFARIO,
    GET_ERROR_CREDITO_QUIROGRAFARIO,
    GET_CREDITO_HIPOTECARIO,
    LOADING_CREDITO_HIPOTECARIO,
    GET_ERROR_CREDITO_HIPOTECARIO,
    GET_POLIZAS,
    LOADING_POLIZAS,
    GET_ERROR_POLIZAS,
    GET_HISTORY_MASIVE,
    LOADING_HISTORY_MASIVE,
    GET_ERROR_HISTORY_MASIVE,
    LOADING_ERROR_DOCUMENT_MASIVE,
    GET_FAILED_ERROR_DOCUMENT_MASIVE,
    GET_DOCUMENT_ERROR_MASIVE,
    GET_COUNT_PROCESS_MASIVE,
    LOADING_COUNT_PROCESS_MASIVE,
    GET_ERROR_COUNT_PROCESS_MASIVE,
    RESET_COUNT_PROCESS_MASIVE,
    GET_USER_REALM,
    LOADING_USER_REALM,
    GET_ERROR_USER_REALM,
    RESET_USER_REALM,
    LOADING_DOWNLOAD_REPORT_CONSULT,
    GET_DOWNLOAD_REPORT_CONSULT,
    GET_ERROR_DOWNLOAD_REPORT_CONSULT,
    RESET_DOWNLOAD_REPORT_CONSULT,
    GET_COBERTURA_SALUD,
    GET_ERROR_COBERTURA_SALUD,
    LOADING_COBERTURA_SALUD,
    GET_RETIRED_PERSON, LOADING_RETIRED_PERSON, GET_ERROR_RETIRED_PERSON, LOADING_RETAILS_PERSON, GET_RETAILS_PERSON,
    GET_ERROR_RETAILS_PERSON, GET_ERROR_VEHICLE_CONDITION, GET_VEHICLE_CONDITION, LOADING_VEHICLE_CONDITION,
    LOADING_CUSTOMER_PAYMENT_BEHAVIOR, GET_CUSTOMER_PAYMENT_BEHAVIOR, GET_ERROR_CUSTOMER_PAYMENT_BEHAVIOR,
    LOADING_SUPA_NOVADATA, GET_SUPA_NOVADATA, GET_ERROR_SUPA_NOVADATA,
    LOADING_SRI_IMPUESTOS, GET_SRI_IMPUESTOS, GET_ERROR_SRI_IMPUESTOS,
    LOADING_IMPEDIMENTO_CARGOS, GET_IMPEDIMENTO_CARGOS, GET_ERROR_IMPEDIMENTO_CARGOS,
    LOADING_IMPEDIMENTO_CARGOS_PDF, GET_IMPEDIMENTO_CARGOS_PDF, GET_ERROR_IMPEDIMENTO_CARGOS_PDF,
    LOADING_SERCOP, GET_SERCOP, GET_ERROR_SERCOP
} from "../../actionsType/person/personActionType"

const INITIAL_STATE = {
    loading_personInfo: false,
    error_personInfo: null,
    success_personInfo: null,

    loading_direcciones: false,
    error_direcciones: null,
    success_direcciones: null,

    loading_telefonos: false,
    error_telefonos: null,
    success_telefonos: null,

    loading_email: false,
    error_email: null,
    success_email: null,

    loading_titulo: false,
    error_titulo: null,
    success_titulo: null,

    loading_padres: false,
    error_padres: null,
    success_padres: null,

    loading_hijos: false,
    error_hijos: null,
    success_hijos: null,

    loading_laboralHistorico: false,
    error_laboralHistorico: null,
    success_laboralHistorico: null,

    loading_contribuyente_impuestos: false,
    error_contribuyente_impuestos: null,
    success_contribuyente_impuestos: null,

    loading_mecanizadoGrafico: false,
    error_mecanizadoGrafico: null,
    success_mecanizadoGrafico: null,
    valueReducer: null,

    loading_mecanizado: false,
    error_mecanizado: null,
    success_mecanizado: null,

    loading_inversiones: false,
    error_inversiones: null,
    success_inversiones: null,

    loading_cargosEmpresariales: false,
    error_cargosEmpresariales: null,
    success_cargosEmpresariales: null,

    loading_bienesInmuebles: false,
    error_bienesInmuebles: null,
    success_bienesInmuebles: null,

    loading_novaData: false,
    error_novaData: null,
    success_novaData: null,

    loading_antecedentes: false,
    error_antecedentes: null,
    success_antecedentes: null,

    loading_demandaOfendido: false,
    error_demandaOfendido: null,
    success_demandaOfendido: null,

    loading_demandaOfensor: false,
    error_demandaOfensor: null,
    success_demandaOfensor: null,

    loading_licencia: false,
    error_licencia: null,
    success_licencia: null,

    loading_vehiculo: false,
    error_vehiculo: null,
    success_vehiculo: null,

    loading_denuncia: false,
    error_denuncia: null,
    success_denuncia: null,

    loading_supa: false,
    error_supa: null,
    success_supa: null,

    loading_supa_novadata: false,
    error_supa_novadata: null,
    success_supa_novadata: null,

    loading_sri_impuestos: false,
    error_sri_impuestos: null,
    success_sri_impuestos: null,

    loading_impedimento_cargos: false,
    error_impedimento_cargos: null,
    success_impedimento_cargos: null,
    loading_impedimento_cargos_pdf: false,

    loading_sercop: false,
    error_sercop: null,
    success_sercop: null,

    loading_listaControl: false,
    error_listaControl: null,
    success_listaControl: null,

    loading_ant: false,
    error_ant: null,
    success_ant: null,

    loading_infNombre: false,
    error_infNombre: null,
    success_infNombre: null,

    loading_cedula: false,
    error_cedula: null,
    success_cedulaIncorrecta: null,
    success_cedulaCorrecta: null,

    loading_deleteCed: false,
    error_deleteCed: null,
    success_deleteCed: null,

    loading_createCed: false,
    error_createCed: null,
    success_createCed: null,

    loading_coopInfo: false,
    error_coopInfo: null,
    success_coopInfo: null,

    loading_dinersInfo: false,
    error_dinersInfo: null,
    success_dinersInfo: null,

    loading_superInfo: false,
    error_superInfo: null,
    success_superInfo: null,

    loading_vacunaInfo: false,
    error_vacunaInfo: null,
    success_vacunaInfo: null,

    loading_establecimientoInfo: false,
    error_establecimientoInfo: null,
    success_establecimientoInfo: null,

    loading_contribuyenteInfo: false,
    error_contribuyenteInfo: null,
    success_contribuyenteInfo: null,

    loading_redirectUrl: false,
    error_redirectUrl: null,
    success_redirectUrl: null,

    loading_empresaRealm: false,
    error_empresaRealm: null,
    success_empresaRealm: null,

    loading_listaNegra: false,
    error_listaNegra: null,
    success_listaNegra: null,

    loading_afiliacion_isspol: false,
    error_afiliacion_isspol: null,
    success_afiliacion_isspol: null,

    loading_afiliacion_iess: false,
    error_afiliacion_iess: null,
    success_afiliacion_iess: null,

    loading_afiliacion_iess_pdf: false,
    error_afiliacion_iess_pdf: null,
    success_afiliacion_iess_pdf: null,

    loading_afiliacion_isspol_pdf: false,
    error_afiliacion_isspol_pdf: null,
    success_afiliacion_isspol_pdf: null,

    loading_pensionista_pdf: false,
    error_pensionista_pdf: null,
    success_pensionista_pdf: null,

    loading_pensionista: false,
    error_pensionista: null,
    success_pensionista: null,


    loading_deudas_amt: false,
    error_deudas_amt: null,
    success_deudas_amt: null,

    loading_list_ofac: false,
    error_list_ofac: null,
    success_list_ofac: null,

    loading_deuda_emov: false,
    error_deuda_emov: null,
    success_deuda_emov: null,

    loading_file_request: false,
    success_file_request: null,
    error_file_request: null,

    loading_file_upload: false,
    success_file_upload: null,
    error_file_upload: null,

    loading_demandas_batch: false,
    success_demandas_batch: null,
    error_demandas_batch: null,

    loading_download_activity_request: false,
    success_download_activity_request: null,
    error_download_activity_request: null,

    loading_demandas_batch_progress: false,
    success_demandas_batch_progress: null,
    error_demandas_batch_progress: null,

    total: 0,
    procesadas: 0,
    correctas: 0,
    incorrectas: 0,
    estado: false,
    progressPercentage: 0,

    loading_afiliacion_issfac_medico: false,
    error_afiliacion_issfac_medico: null,
    success_afiliacion_issfac_medico: null,

    loading_afiliacion_issfac_fuerza_armada: false,
    error_afiliacion_issfac_fuerza_armada: null,
    success_afiliacion_issfac_fuerza_armada: null,

    loading_afiliacion_cumplimiento_patronal: false,
    error_afiliacion_cumplimiento_patronal: null,
    success_afiliacion_cumplimiento_patronal: null,

    loading_afiliacion_cumplimiento_patronal_pdf: false,
    error_afiliacion_cumplimiento_patronal_pdf: null,
    success_afiliacion_cumplimiento_patronal_pdf : null,

    loading_afiliacion_sisspol: false,
    error_afiliacion_sisspol: null,
    success_afiliacion_sisspol: null,

    loading_afiliacion_sisspol_pdf: false,
    error_afiliacion_sisspol_pdf: null,
    success_afiliacion_sisspol_pdf : null,

    loading_accidentRateInfo: false,
    error_accidentRateInfo: null,
    success_accidentRateInfo: null,

    loading_super_deudores: false,
    error_super_deudores: null,
    success_super_deudores: null,

    loading_persona_empleados: false,
    error_persona_empleados: null,
    success_persona_empleados: null,

    loading_credito_hipotecario: false,
    error_credito_hipotecario: null,
    success_credito_hipotecario: null,

    loading_credito_quirografario: false,
    error_credito_quirografario: null,
    success_credito_quirografario: null,

    loading_superIntendencia_polizas: false,
    error_superIntendencia_polizas: null,
    success_superIntendencia_polizas: null,

    loading_history_masive: false,
    error_history_masive: null,
    success_history_masive: null,

    loading_error_masive: false,
    error_error_masive: null,
    success_error_masive: null,

    loading_count_process_masive: false,
    error_count_process_masive: null,
    success_count_process_masive: null,

    loading_user_realm: false,
    error_user_realm: null,
    success_user_realm: null,

    loading_download_report_consult: false,
    error_download_report_consult: null,
    success_download_report_consult: null,

    loading_cobertura_salud: false,
    error_cobertura_salud: null,
    success_cobertura_salud: null,

    loading_retired_person: false,
    error_retired_person: null,
    success_retired_person: null,

    loading_retail_person: false,
    error_retail_person: null,
    success_retail_person: null,

    loading_vehicle_condition: false,
    error_vehicle_condition: null,
    success_vehicle_condition: null,

    loading_customer_payment: false,
    error_customer_payment: null,
    success_customer_payment: null
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESET_STATE_PERSON:
            return {
                ...state,
                loading_personInfo: false,
                error_personInfo: null,
                loading_direcciones: false,
                error_direcciones: null,
                loading_telefonos: false,
                error_telefonos: null,
                loading_email: false,
                error_email: null,
                loading_titulo: false,
                error_titulo: null,
                loading_padres: false,
                error_padres: null,
                loading_hijos: false,
                error_hijos: null,
                loading_laboralHistorico: false,
                error_laboralHistorico: null,
                loading_mecanizadoGrafico: false,
                error_mecanizadoGrafico: null,
                loading_mecanizado: false,
                error_mecanizado: null,
                loading_inversiones: false,
                error_inversiones: null,
                loading_cargosEmpresariales: false,
                error_cargosEmpresariales: null,
                loading_bienesInmuebles: false,
                error_bienesInmuebles: null,
                loading_novaData: false,
                error_novaData: null,
                loading_antecedentes: false,
                error_antecedentes: null,
                loading_demandaOfendido: false,
                error_demandaOfendido: null,
                loading_demandaOfensor: false,
                error_demandaOfensor: null,
                loading_licencia: false,
                error_licencia: null,
                loading_vehiculo: false,
                error_vehiculo: null,
                loading_denuncia: false,
                error_denuncia: null,
                loading_supa: false,
                error_supa: null,
                loading_supa_novadata: false,
                error_supa_novadata: null,
                loading_sri_impuestos: false,
                error_sri_impuestos: null,
                loading_impedimento_cargos: false,
                error_impedimento_cargos: null,
                loading_impedimento_cargos_pdf: false,
                loading_sercop: false,
                error_sercop: null,
                loading_listaControl: false,
                error_listaControl: null,
                loading_ant: false,
                error_ant: null,
                loading_infNombre: false,
                error_infNombre: null,
                loading_cedula: false,
                error_cedula: null,
                loading_deleteCed: false,
                error_deleteCed: null,
                loading_createCed: false,
                error_createCed: null,
                loading_coopInfo: false,
                error_coopInfo: null,
                loading_dinersInfo: false,
                error_dinersInfo: null,
                loading_superInfo: false,
                error_superInfo: null,
                loading_vacunaInfo: false,
                error_vacunaInfo: null,
                loading_establecimientoInfo: false,
                error_establecimientoInfo: null,
                loading_contribuyenteInfo: false,
                error_contribuyenteInfo: null,
                loading_redirectUrl: false,
                error_redirectUrl: null,
                loading_empresaRealm: false,
                error_empresaRealm: null,
                loading_listaNegra: false,
                error_listaNegra: null,
                loading_afiliacion_isspol: false,
                loading_afiliacion_iess: false,
                loading_afiliacion_iess_pdf: false,
                loading_afiliacion_isspol_pdf: false,
                loading_pensionista_pdf: false,
                error_afiliacion_isspol: null,
                error_afiliacion_iess: null,
                error_afiliacion_iess_pdf: null,
                error_afiliacion_isspol_pdf: null,
                error_pensionista_pdf: null,
                loading_deudas_amt: false,
                loading_list_ofac: false,
                loading_deuda_emov: false,
                error_deuda_emov: null,
                error_deudas_amt: null,
                error_list_ofac: null,
                loading_pensionista: false,
                error_pensionista: null,
                loading_file_upload: false,
                error_file_upload: null,
                loading_download_activity_request: false,
                error_download_activity_request: null,
                loading_demandas_batch: false,
                error_demandas_batch: null,
                error_afiliacion_issfac_medico: null,
                loading_afiliacion_issfac_medico: false,
                error_afiliacion_issfac_fuerza_armada: null,
                loading_afiliacion_issfac_fuerza: false,
                loading_afiliacion_cumplimiento_patronal: false,
                error_afiliacion_cumplimiento_patronal: null,
                loading_afiliacion_cumplimiento_patronal_pdf: false,
                error_afiliacion_cumplimiento_patronal_pdf: null,
                loading_afiliacion_sisspol: false,
                error_afiliacion_sisspol: null,
                loading_afiliacion_sisspol_pdf: false,
                error_afiliacion_sisspol_pdf: null,
                loading_accidentRateInfo: false,
                error_accidentRateInfo: null,
                loading_super_deudores: false,
                error_super_deudores: null,
                loading_persona_empleados: false,
                error_persona_empleados: null,
                loading_credito_hipotecario: false,
                error_credito_hipotecario: null,
                loading_credito_quirografario: false,
                error_credito_quirografario: null,
                loading_superIntendencia_polizas: false,
                error_superIntendencia_polizas: null,
                loading_history_masive: false,
                error_history_masive: null,
                loading_error_masive: false,
                error_error_masive: null,
                loading_count_process_masive: false,
                error_count_process_masive: null,
                loading_user_realm: false,
                error_user_realm: null,
                error_download_report_consult: null,
                loading_cobertura_salud: false,
                error_cobertura_salud: null,
                error_retired_person: null,
                error_retail_person: null,
                error_vehicle_condition: null,
                error_customer_payment: null,
                loading_retired_person: false,
                loading_retail_person: false,
                loading_vehicle_condition: false,
                loading_customer_payment: false,
                success_download_report_consult: null
            }
        case RESET_VALUE:
            return {
                ...state,
                valueReducer: null
            }
        case RESET_SUCCESS:
            return {
                ...state,
                success_personInfo: null,
                success_direcciones: null,
                success_telefonos: null,
                success_email: null,
                success_titulo: null,
                success_padres: null,
                success_hijos: null,
                success_laboralHistorico: null,
                success_mecanizadoGrafico: null,
                success_mecanizado: null,
                success_inversiones: null,
                success_cargosEmpresariales: null,
                success_bienesInmuebles: null,
                success_novaData: null,
                success_deudas_amt: null,
                success_list_ofac: null,
                success_pensionista: null,
                success_antecedentes: null,
                success_demandaOfendido: null,
                success_demandaOfensor: null,
                success_licencia: null,
                success_vehiculo: null,
                success_denuncia: null,
                success_supa: null,
                success_supa_novadata: null,
                success_sri_impuestos: null,
                success_impedimento_cargos: null,
                success_sercop: null,
                success_listaControl: null,
                success_ant: null,
                success_infNombre: null,
                success_cedulaIncorrecta: null,
                success_cedulaCorrecta: null,
                success_coopInfo: null,
                success_dinersInfo: null,
                success_superInfo: null,
                success_vacunaInfo: null,
                success_establecimientoInfo: null,
                success_contribuyenteInfo: null,
                success_redirectUrl: null,
                success_empresaRealm: null,
                success_listaNegra: null,
                success_afiliacion_isspol: null,
                success_afiliacion_iess: null,
                success_afiliacion_iess_pdf: null,
                success_afiliacion_isspol_pdf: null,
                success_deuda_emov: null,
                success_download_activity_request: null,
                success_demandas_batch: null,
                success_file_upload: null,
                success_file_request: null,
                success_afiliacion_issfac_medico: null,
                success_afiliacion_issfac_fuerza_armada: null,
                success_afiliacion_cumplimiento_patronal: null,
                success_afiliacion_cumplimiento_patronal_pdf: null,
                success_afiliacion_sisspol_pdf : null,
                success_afiliacion_sisspol: null,
                success_accidentRateInfo: null,
                success_super_deudores: null,
                success_persona_empleados: null,
                success_credito_hipotecario: null,
                success_credito_quirografario: null,
                success_superIntendencia_polizas: null,
                success_history_masive: null,
                success_failed_error_masive: null,
                success_count_process_masive: null,
                success_user_realm: null,
                success_download_report_consult: null,
                success_cobertura_consult: null,
                success_retired_person: null,
                success_retail_person: null
            }
        case SET_VALUE:
            return {
                ...state,
                valueReducer: action.payload
            }

        case GET_CONTRIBUYENTEINFO:
            return {
                ...state,
                loading_contribuyenteInfo: false,
                error_contribuyenteInfo: null,
                success_contribuyenteInfo: action.payload
            }
        case LOADING_CONTRIBUYENTEINFO:
            return {
                ...state,
                loading_contribuyenteInfo: true,
                error_contribuyenteInfo: null,
                success_contribuyenteInfo: null
            }
        case GET_ERROR_CONTRIBUYENTEINFO:
            return {
                ...state,
                error_contribuyenteInfo: action.payload,
                loading_contribuyenteInfo: false
            }

        case GET_ESTABLECIMIENTOINFO:
            return {
                ...state,
                loading_establecimientoInfo: false,
                error_establecimientoInfo: null,
                success_establecimientoInfo: action.payload
            }
        case LOADING_ESTABLECIMIENTOINFO:
            return {
                ...state,
                loading_establecimientoInfo: true,
                error_establecimientoInfo: null,
                success_establecimientoInfo: null
            }
        case GET_ERROR_ESTABLECIMIENTOINFO:
            return {
                ...state,
                error_establecimientoInfo: action.payload,
                loading_establecimientoInfo: false
            }

        case GET_VACUNAINFO:
            return {
                ...state,
                loading_vacunaInfo: false,
                error_vacunaInfo: null,
                success_vacunaInfo: action.payload
            }
        case LOADING_VACUNAINFO:
            return {
                ...state,
                loading_vacunaInfo: true,
                error_vacunaInfo: null,
                success_vacunaInfo: null
            }
        case GET_ERROR_VACUNAINFO:
            return {
                ...state,
                error_vacunaInfo: action.payload,
                loading_vacunaInfo: false
            }

        case GET_SUPERINFO:
            return {
                ...state,
                loading_superInfo: false,
                error_superInfo: null,
                success_superInfo: action.payload
            }
        case LOADING_SUPERINFO:
            return {
                ...state,
                loading_superInfo: true,
                error_superInfo: null,
                success_superInfo: null
            }
        case GET_ERROR_SUPERINFO:
            return {
                ...state,
                error_superInfo: action.payload,
                loading_superInfo: false
            }

        case GET_DINERSINFO:
            return {
                ...state,
                loading_dinersInfo: false,
                error_dinersInfo: null,
                success_dinersInfo: action.payload
            }
        case LOADING_DINERSINFO:
            return {
                ...state,
                loading_dinersInfo: true,
                error_dinersInfo: null,
                success_dinersInfo: null
            }
        case GET_ERROR_DINERSINFO:
            return {
                ...state,
                error_dinersInfo: action.payload,
                loading_dinersInfo: false
            }

        case GET_COOPINFO:
            return {
                ...state,
                loading_coopInfo: false,
                error_coopInfo: null,
                success_coopInfo: action.payload
            }
        case LOADING_COOPINFO:
            return {
                ...state,
                loading_coopInfo: true,
                error_coopInfo: null,
                success_coopInfo: null
            }
        case GET_ERROR_COOPINFO:
            return {
                ...state,
                error_coopInfo: action.payload,
                loading_coopInfo: false
            }

        case GET_PERSONINFO:
            return {
                ...state,
                loading_personInfo: false,
                error_personInfo: null,
                success_personInfo: action.payload
            }
        case LOADING_PERSONINFO:
            return {
                ...state,
                loading_personInfo: true,
                error_personInfo: null,
                success_personInfo: null
            }
        case GET_ERROR_PERSONINFO:
            return {
                ...state,
                error_personInfo: action.payload,
                loading_personInfo: false
            }

        case GET_DIRECCIONES:
            return {
                ...state,
                loading_direcciones: false,
                error_direcciones: null,
                success_direcciones: action.payload
            }
        case LOADING_DIRECCIONES:
            return {
                ...state,
                loading_direcciones: true,
                error_direcciones: null,
                success_direcciones: null
            }
        case GET_ERROR_DIRECCIONES:
            return {
                ...state,
                error_direcciones: action.payload,
                loading_direcciones: false
            }

        case GET_TELEFONOS:
            return {
                ...state,
                loading_telefonos: false,
                error_telefonos: null,
                success_telefonos: action.payload
            }
        case LOADING_TELEFONOS:
            return {
                ...state,
                loading_telefonos: true,
                error_telefonos: null,
                success_telefonos: null
            }
        case GET_ERROR_TELEFONOS:
            return {
                ...state,
                error_telefonos: action.payload,
                loading_telefonos: false
            }

        case GET_EMAIL:
            return {
                ...state,
                loading_email: false,
                error_email: null,
                success_email: action.payload
            }
        case LOADING_EMAIL:
            return {
                ...state,
                loading_email: true,
                error_email: null,
                success_email: null
            }
        case GET_ERROR_EMAIL:
            return {
                ...state,
                error_email: action.payload,
                loading_email: false
            }

        case GET_TITULOS:
            return {
                ...state,
                loading_titulo: false,
                error_titulo: null,
                success_titulo: action.payload
            }
        case LOADING_TITULOS:
            return {
                ...state,
                loading_titulo: true,
                error_titulo: null,
                success_titulo: null
            }
        case GET_ERROR_TITULOS:
            return {
                ...state,
                error_titulo: action.payload,
                loading_titulo: false
            }

        case GET_PADRES:
            return {
                ...state,
                loading_padres: false,
                error_padres: null,
                success_padres: action.payload
            }
        case LOADING_PADRES:
            return {
                ...state,
                loading_padres: true,
                error_padres: null,
                success_padres: null
            }
        case GET_ERROR_PADRES:
            return {
                ...state,
                error_padres: action.payload,
                loading_padres: false
            }

        case GET_HIJOS:
            return {
                ...state,
                loading_hijos: false,
                error_hijos: null,
                success_hijos: action.payload
            }
        case LOADING_HIJOS:
            return {
                ...state,
                loading_hijos: true,
                error_hijos: null,
                success_hijos: null
            }
        case GET_ERROR_HIJOS:
            return {
                ...state,
                error_hijos: action.payload,
                loading_hijos: false
            }

        case GET_LABORALHISTORICO:
            return {
                ...state,
                loading_laboralHistorico: false,
                error_laboralHistorico: null,
                success_laboralHistorico: action.payload
            }
        case LOADING_LABORALHISTORICO:
            return {
                ...state,
                loading_laboralHistorico: true,
                error_laboralHistorico: null,
                success_laboralHistorico: null
            }
        case GET_ERROR_LABORALHISTORICO:
            return {
                ...state,
                error_laboralHistorico: action.payload,
                loading_laboralHistorico: false
            }

        case GET_CONTRIBUYENTE_IMPUESTOS:
            return {
                ...state,
                loading_contribuyente_impuestos: false,
                error_contribuyente_impuestos: null,
                success_contribuyente_impuestos: action.payload
            }
        case LOADING_CONTRIBUYENTE_IMPUESTOS:
            return {
                ...state,
                loading_contribuyente_impuestos: true,
                error_contribuyente_impuestos: null,
                success_contribuyente_impuestos: null
            }
        case GET_ERROR_CONTRIBUYENTE_IMPUESTOS:
            return {
                ...state,
                error_contribuyente_impuestos: action.payload,
                loading_contribuyente_impuestos: false
            }

        case GET_MECANIZADOGRAFICO:
            return {
                ...state,
                loading_mecanizadoGrafico: false,
                error_mecanizadoGrafico: null,
                success_mecanizadoGrafico: action.payload
            }
        case LOADING_MECANIZADOGRAFICO:
            return {
                ...state,
                loading_mecanizadoGrafico: true,
                error_mecanizadoGrafico: null,
                success_mecanizadoGrafico: null
            }
        case GET_ERROR_MECANIZADOGRAFICO:
            return {
                ...state,
                error_mecanizadoGrafico: action.payload,
                loading_mecanizadoGrafico: false
            }

        case GET_MECANIZADO:
            return {
                ...state,
                loading_mecanizado: false,
                error_mecanizado: null,
                success_mecanizado: action.payload
            }
        case LOADING_MECANIZADO:
            return {
                ...state,
                loading_mecanizado: true,
                error_mecanizado: null,
                success_mecanizado: null
            }
        case GET_ERROR_MECANIZADO:
            return {
                ...state,
                error_mecanizado: action.payload,
                loading_mecanizado: false
            }

        case GET_INVERSIONES:
            return {
                ...state,
                loading_inversiones: false,
                error_inversiones: null,
                success_inversiones: action.payload
            }
        case LOADING_INVERSIONES:
            return {
                ...state,
                loading_inversiones: true,
                error_inversiones: null,
                success_inversiones: null
            }
        case GET_ERROR_INVERSIONES:
            return {
                ...state,
                error_inversiones: action.payload,
                loading_inversiones: false
            }
        case GET_CARGOS_EMPRESARIALES:
            return {
                ...state,
                loading_cargosEmpresariales: false,
                error_cargosEmpresariales: null,
                success_cargosEmpresariales: action.payload
            }
        case LOADING_CARGOS_EMPRESARIALES:
            return {
                ...state,
                loading_cargosEmpresariales: true,
                error_cargosEmpresariales: null,
                success_cargosEmpresariales: null
            }
        case GET_ERROR_CARGOS_EMPRESARIALES:
            return {
                ...state,
                error_cargosEmpresariales: action.payload,
                loading_cargosEmpresariales: false
            }

        case GET_BIENESINMUEBLES:
            return {
                ...state,
                loading_bienesInmuebles: false,
                error_bienesInmuebles: null,
                success_bienesInmuebles: action.payload
            }
        case LOADING_BIENESINMUEBLES:
            return {
                ...state,
                loading_bienesInmuebles: true,
                error_bienesInmuebles: null,
                success_bienesInmuebles: null
            }
        case GET_ERROR_BIENESINMUEBLES:
            return {
                ...state,
                error_bienesInmuebles: action.payload,
                loading_bienesInmuebles: false
            }

        case GET_COGNODATA:
            return {
                ...state,
                loading_novaData: false,
                error_novaData: null,
                success_novaData: action.payload
            }
        case LOADING_COGNODATA:
            return {
                ...state,
                loading_novaData: true,
                error_novaData: null,
                success_novaData: null
            }
        case GET_ERROR_COGNODATA:
            return {
                ...state,
                error_novaData: action.payload,
                loading_novaData: false
            }

        case GET_ANTECEDENTES:
            return {
                ...state,
                loading_antecedentes: false,
                error_antecedentes: null,
                success_antecedentes: action.payload
            }
        case LOADING_ANTECEDENTES:
            return {
                ...state,
                loading_antecedentes: true,
                error_antecedentes: null,
                success_antecedentes: null
            }
        case GET_ERROR_ANTECEDENTES:
            return {
                ...state,
                error_antecedentes: action.payload,
                loading_antecedentes: false
            }

        case GET_DEMANDAOFENDIDO:
            return {
                ...state,
                loading_demandaOfendido: false,
                error_demandaOfendido: null,
                success_demandaOfendido: action.payload
            }
        case LOADING_DEMANDAOFENDIDO:
            return {
                ...state,
                loading_demandaOfendido: true,
                error_demandaOfendido: null,
                success_demandaOfendido: null
            }
        case GET_ERROR_DEMANDAOFENDIDO:
            return {
                ...state,
                error_demandaOfendido: action.payload,
                loading_demandaOfendido: false
            }

        case GET_DEMANDAOFENSOR:
            return {
                ...state,
                loading_demandaOfensor: false,
                error_demandaOfensor: null,
                success_demandaOfensor: action.payload
            }
        case LOADING_DEMANDAOFENSOR:
            return {
                ...state,
                loading_demandaOfensor: true,
                error_demandaOfensor: null,
                success_demandaOfensor: null
            }
        case GET_ERROR_DEMANDAOFENSOR:
            return {
                ...state,
                error_demandaOfensor: action.payload,
                loading_demandaOfensor: false
            }

        case GET_LICENCIA:
            return {
                ...state,
                loading_licencia: false,
                error_licencia: null,
                success_licencia: action.payload
            }
        case LOADING_LICENCIA:
            return {
                ...state,
                loading_licencia: true,
                error_licencia: null,
                success_licencia: null
            }
        case GET_ERROR_LICENCIA:
            return {
                ...state,
                error_licencia: action.payload,
                loading_licencia: false
            }

        case GET_VEHICULO:
            return {
                ...state,
                loading_vehiculo: false,
                error_vehiculo: null,
                success_vehiculo: action.payload
            }
        case LOADING_VEHICULO:
            return {
                ...state,
                loading_vehiculo: true,
                error_vehiculo: null,
                success_vehiculo: null
            }
        case GET_ERROR_VEHICULO:
            return {
                ...state,
                error_vehiculo: action.payload,
                loading_vehiculo: false
            }

        case GET_DENUNCIAS:
            return {
                ...state,
                loading_denuncia: false,
                error_denuncia: null,
                success_denuncia: action.payload
            }
        case LOADING_DENUNCIAS:
            return {
                ...state,
                loading_denuncia: true,
                error_denuncia: null,
                success_denuncia: null
            }
        case GET_ERROR_DENUNCIAS:
            return {
                ...state,
                error_denuncia: action.payload,
                loading_denuncia: false
            }

        case GET_SUPA:
            return {
                ...state,
                loading_supa: false,
                error_supa: null,
                success_supa: action.payload
            }
        case LOADING_SUPA:
            return {
                ...state,
                loading_supa: true,
                error_supa: null,
                success_supa: null
            }
        case GET_ERROR_SUPA:
            return {
                ...state,
                error_supa: action.payload,
                loading_supa: false
            }

        case GET_LISTACONTROL:
            return {
                ...state,
                loading_listaControl: false,
                error_listaControl: null,
                success_listaControl: action.payload
            }
        case LOADING_LISTACONTROL:
            return {
                ...state,
                loading_listaControl: true,
                error_listaControl: null,
                success_listaControl: null
            }
        case GET_ERROR_LISTACONTROL:
            return {
                ...state,
                error_listaControl: action.payload,
                loading_listaControl: false
            }

        case GET_ANT:
            return {
                ...state,
                loading_ant: false,
                error_ant: null,
                success_ant: action.payload
            }
        case LOADING_ANT:
            return {
                ...state,
                loading_ant: true,
                error_ant: null,
                success_ant: null
            }
        case GET_ERROR_ANT:
            return {
                ...state,
                error_ant: action.payload,
                loading_ant: false
            }

        case GET_INFNOMBRE:
            return {
                ...state,
                loading_infNombre: false,
                error_infNombre: null,
                success_infNombre: action.payload
            }
        case LOADING_INFNOMBRE:
            return {
                ...state,
                loading_infNombre: true,
                error_infNombre: null,
                success_infNombre: null
            }
        case GET_ERROR_INFNOMBRE:
            return {
                ...state,
                error_infNombre: action.payload,
                loading_infNombre: false
            }

        case GET_CEDULACORRECTA:
            return {
                ...state,
                loading_cedula: false,
                error_cedula: null,
                success_cedulaCorrecta: action.payload
            }
        case GET_CEDULAINCORREC:
            return {
                ...state,
                loading_cedula: false,
                error_cedula: null,
                success_cedulaIncorrecta: action.payload
            }
        case LOADING_CEDULA:
            return {
                ...state,
                loading_cedula: true,
                error_cedula: null,
                success_cedulaIncorrecta: null,
                success_cedulaCorrecta: null
            }
        case GET_ERROR_CEDULA:
            return {
                ...state,
                error_cedula: action.payload,
                loading_cedula: false
            }

        case GET_CEDULACOUNT:
            return {
                ...state,
                loading_cedulaCount: false,
                error_cedulaCount: null,
                success_cedulaCount: action.payload
            }
        case LOADING_CEDULACOUNT:
            return {
                ...state,
                loading_cedulaCount: true,
                error_cedulaCount: null,
                success_cedulaCount: null
            }
        case GET_ERROR_CEDULACOUNT:
            return {
                ...state,
                error_cedulaCount: action.payload,
                loading_cedulaCount: false
            }

        case GET_DELETECEDULA:
            return {
                ...state,
                loading_deleteCed: false,
                error_deleteCed: null,
                success_deleteCed: action.payload
            }
        case LOADING_DELETECEDULA:
            return {
                ...state,
                loading_deleteCed: true,
                error_deleteCed: null,
                success_deleteCed: null
            }
        case GET_ERROR_DELETECEDULA:
            return {
                ...state,
                error_deleteCed: action.payload,
                loading_deleteCed: false
            }

        case GET_CREATECEDULA:
            return {
                ...state,
                loading_createCed: false,
                error_createCed: null,
                success_createCed: action.payload
            }
        case LOADING_CREATECEDULA:
            return {
                ...state,
                loading_createCed: true,
                error_createCed: null,
                success_createCed: null
            }
        case GET_ERROR_CREATECEDULA:
            return {
                ...state,
                error_createCed: action.payload,
                loading_createCed: false
            }
        case GET_REDIRECT_URL:
            return {
                ...state,
                loading_redirectUrl: false,
                error_redirectUrl: null,
                success_redirectUrl: action.payload
            }
        case LOADING_REDIRECT_URL:
            return {
                ...state,
                loading_redirectUrl: true,
                error_redirectUrl: null,
                success_redirectUrl: null
            }
        case GET_ERROR_REDIRECT_URL:
            return {
                ...state,
                error_redirectUrl: action.payload,
                loading_redirectUrl: false
            }
        case RESET_REDIRECT_URL:
            return {
                ...state,
                success_redirectUrl: null,
                loading_redirectUrl: false,
                error_redirectUrl: null
            }
        case GET_EMPRESA_REALM:
            return {
                ...state,
                loading_empresaRealm: false,
                error_empresaRealm: null,
                success_empresaRealm: action.payload
            }
        case LOADING_EMPRESA_REALM:
            return {
                ...state,
                loading_empresaRealm: true,
                error_empresaRealm: null,
                success_empresaRealm: null
            }
        case GET_ERROR_EMPRESA_REALM:
            return {
                ...state,
                error_empresaRealm: action.payload,
                loading_empresaRealm: false
            }

        case GET_LISTAS_NEGRAS:
            return {
                ...state,
                loading_listaNegra: false,
                error_listaNegra: null,
                success_listaNegra: action.payload
            }
        case LOADING_LISTAS_NEGRAS:
            return {
                ...state,
                loading_listaNegra: true,
                error_listaNegra: null,
                success_listaNegra: null
            }
        case GET_ERROR_LISTAS_NEGRAS:
            return {
                ...state,
                error_listaNegra: action.payload,
                loading_listaNegra: false
            }

        case GET_AFILIACION_ISSPOL:
            return {
                ...state,
                loading_afiliacion_isspol: false,
                error_afiliacion_isspol: null,
                success_afiliacion_isspol: action.payload
            }
        case LOADING_AFILIACION_ISSPOL:
            return {
                ...state,
                loading_afiliacion_isspol: true,
                error_afiliacion_isspol: null,
                success_afiliacion_isspol: null
            }
        case GET_ERROR_AFILIACION_ISSPOL:
            return {
                ...state,
                error_afiliacion_isspol: action.payload,
                loading_afiliacion_isspol: false
            }

        case GET_AFILIACION_IESS:
            return {
                ...state,
                loading_afiliacion_iess: false,
                error_afiliacion_iess: null,
                success_afiliacion_iess: action.payload
            }
        case LOADING_AFILIACION_IESS:
            return {
                ...state,
                loading_afiliacion_iess: true,
                error_afiliacion_iess: null,
                success_afiliacion_iess: null
            }
        case GET_ERROR_AFILIACION_IESS:
            return {
                ...state,
                error_afiliacion_iess: action.payload,
                loading_afiliacion_iess: false
            }


        case GET_AFILIACION_IESS_PDF:
            return {
                ...state,
                loading_afiliacion_iess_pdf: false,
                error_afiliacion_iess_pdf: null,
                success_afiliacion_iess_pdf: action.payload
            }
        case LOADING_AFILIACION_IESS_PDF:
            return {
                ...state,
                loading_afiliacion_iess_pdf: true,
                error_afiliacion_iess_pdf: null,
                success_afiliacion_iess_pdf: null
            }
        case GET_ERROR_AFILIACION_IESS_PDF:
            return {
                ...state,
                error_afiliacion_iess_pdf: action.payload,
                loading_afiliacion_iess_pdf: false
            }

        case GET_AFILIACION_ISSPOL_PDF:
            return {
                ...state,
                loading_afiliacion_isspol_pdf: false,
                error_afiliacion_isspol_pdf: null,
                success_afiliacion_isspol_pdf: action.payload
            }
        case LOADING_AFILIACION_ISSPOL_PDF:
            return {
                ...state,
                loading_afiliacion_isspol_pdf: true,
                error_afiliacion_isspol_pdf: null,
                success_afiliacion_isspol_pdf: null
            }
        case GET_ERROR_AFILIACION_ISSPOL_PDF:
            return {
                ...state,
                error_afiliacion_isspol_pdf: action.payload,
                loading_afiliacion_isspol_pdf: false
            }

        case GET_PERSONA_PENSIONISTA:
            return {
                ...state,
                loading_pensionista: false,
                error_pensionista: null,
                success_pensionista: action.payload
            }
        case LOADING_PERSONA_PENSIONISTA:
            return {
                ...state,
                loading_pensionista: true,
                error_pensionista: null,
                success_pensionista: null
            }
        case GET_ERROR_PERSONA_PENSIONISTA:
            return {
                ...state,
                error_pensionista: action.payload,
                loading_pensionista: false
            }

        case GET_PENSIONISTA_PDF:
            return {
                ...state,
                loading_pensionista_pdf: false,
                error_pensionista_pdf: null,
                success_pensionista_pdf: action.payload
            }
        case LOADING_PENSIONISTA_PDF:
            return {
                ...state,
                loading_pensionista_pdf: true,
                error_pensionista_pdf: null,
                success_pensionista_pdf: null
            }
        case GET_ERROR_PENSIONISTA_PDF:
            return {
                ...state,
                error_pensionista_pdf: action.payload,
                loading_pensionista_pdf: false
            }

        case GET_DEUDAS_AMT:
            return {
                ...state,
                loading_deudas_amt: false,
                error_deudas_amt: null,
                success_deudas_amt: action.payload
            }
        case LOADING_DEUDAS_AMT:
            return {
                ...state,
                loading_deudas_amt: true,
                error_deudas_amt: null,
                success_deudas_amt: null
            }
        case GET_ERROR_DEUDAS_AMT:
            return {
                ...state,
                error_deudas_amt: action.payload,
                loading_deudas_amt: false
            }

        case GET_LIST_OFAC:
            return {
                ...state,
                loading_list_ofac: false,
                error_list_ofac: null,
                success_list_ofac: action.payload
            }
        case LOADING_LIST_OFAC:
            return {
                ...state,
                loading_list_ofac: true,
                error_list_ofac: null,
                success_list_ofac: null
            }
        case GET_ERROR_LIST_OFAC:
            return {
                ...state,
                error_list_ofac: action.payload,
                loading_list_ofac: false
            }

        case GET_DEUDAS_EMOV:
            return {
                ...state,
                loading_deuda_emov: false,
                error_deuda_emov: null,
                success_deuda_emov: action.payload
            }
        case LOADING_DEUDAS_EMOV:
            return {
                ...state,
                loading_deuda_emov: true,
                error_deuda_emov: null,
                success_deuda_emov: null
            }
        case GET_ERROR_DEUDAS_EMOV:
            return {
                ...state,
                error_deuda_emov: action.payload,
                loading_deuda_emov: false
            }

        case GET_FILE_REQUEST:
            return {
                ...state,
                loading_file_request: false,
                error_file_request: null,
                success_file_request: action.payload
            }
        case LOADING_FILE_REQUEST:
            return {
                ...state,
                loading_file_request: true,
                error_file_request: null,
                success_file_request: null
            }
        case GET_ERROR_FILE_REQUEST:
            return {
                ...state,
                error_file_request: action.payload,
                loading_file_request: false
            }

        case GET_FILE_UPLOAD:
            return {
                ...state,
                loading_file_upload: false,
                error_file_upload: null,
                success_file_upload: action.payload
            }
        case LOADING_FILE_UPLOAD:
            return {
                ...state,
                loading_file_upload: true,
                error_file_upload: null,
                success_file_upload: null
            }
        case GET_ERROR_FILE_UPLOAD:
            return {
                ...state,
                error_file_upload: action.payload,
                loading_file_upload: false
            }
        case RESET_FILE_REQUEST:
            return {
                ...state,
                loading_file_request: false,
                success_file_request: null,
                error_file_request: null
            }

        case GET_DEMANDAS_BATCH:
            return {
                ...state,
                loading_demandas_batch: false,
                error_demandas_batch: null,
                success_demandas_batch: action.payload
            }
        case LOADING_DEMANDAS_BATCH:
            return {
                ...state,
                loading_demandas_batch: true,
                error_demandas_batch: null,
                success_demandas_batch: null
            }
        case GET_ERROR_DEMANDAS_BATCH:
            return {
                ...state,
                error_demandas_batch: action.payload,
                loading_demandas_batch: false
            }
        case RESET_DEMANDAS_BATCH:
            return {
                ...state,
                loading_demandas_batch: false,
                success_demandas_batch: null,
                error_demandas_batch: null
            }

        case GET_DEMANDAS_BATCH_PROGRESS:
            return {
                ...state,
                loading_demandas_batch_progress: false,
                error_demandas_batch_progress: null,
                success_demandas_batch_progress: action.payload,
                total: action.payload.total,
                correctas: action.payload.correctos,
                incorrectas: action.payload.incorrectos,
                estado: action.payload.estado,
                progressPercentage: action.payload.porcentaje
            }

        case LOADING_DEMANDAS_BATCH_PROGRESS:
            return {
                ...state,
                loading_demandas_batch_progress: true,
                error_demandas_batch_progress: null,
                success_demandas_batch_progress: null,
                estado: true
            }
        case GET_ERROR_DEMANDAS_BATCH_PROGRESS:
            return {
                ...state,
                error_demandas_batch_progress: action.payload,
                loading_demandas_batch_progress: false,
                estado: false,
                progressPercentage: 0
            }

        case GET_DOWNLOAD_ACTIVITY_REQUEST:
            return {
                ...state,
                loading_download_activity_request: false,
                error_download_activity_request: null,
                success_download_activity_request: action.payload
            }
        case LOADING_DOWNLOAD_ACTIVITY_REQUEST:
            return {
                ...state,
                loading_download_activity_request: true,
                error_download_activity_request: null,
                success_download_activity_request: null
            }
        case GET_ERROR_DOWNLOAD_ACTIVITY_REQUEST:
            return {
                ...state,
                error_download_activity_request: action.payload,
                loading_download_activity_request: false
            }
        case RESET_PROGRESS:
            return {
                ...state,
                total: 0,
                correctas: 0,
                incorrectas: 0,
                estado: false,
                progressPercentage: 0,
                success_demandas_batch_progress: null
            }

        case GET_AFILIACION_ISSFAC_MEDICO:
            return {
                ...state,
                loading_afiliacion_issfac_medico: false,
                error_afiliacion_issfac_medico: null,
                success_afiliacion_issfac_medico: action.payload
            }
        case LOADING_AFILIACION_ISSFAC_MEDICO:
            return {
                ...state,
                loading_afiliacion_issfac_medico: true,
                error_afiliacion_issfac_medico: null,
                success_afiliacion_issfac_medico: null
            }
        case GET_ERROR_AFILIACION_ISSFAC_MEDICO:
            return {
                ...state,
                error_afiliacion_issfac_medico: action.payload,
                loading_afiliacion_issfac_medico: false
            }

        case GET_AFILIACION_ISSFAC_FUERZA_ARMADA:
            return {
                ...state,
                loading_afiliacion_issfac_fuerza: false,
                error_afiliacion_issfac_fuerza_armada: null,
                success_afiliacion_issfac_fuerza_armada: action.payload
            }
        case LOADING_AFILIACION_ISSFAC_FUERZA_ARMADA:
            return {
                ...state,
                loading_afiliacion_issfac_fuerza: true,
                error_afiliacion_issfac_fuerza_armada: null,
                success_afiliacion_issfac_fuerza_armada: null
            }
        case GET_ERROR_AFILIACION_ISSFAC_FUERZA_ARMADA:
            return {
                ...state,
                error_afiliacion_issfac_fuerza_armada: action.payload,
                loading_afiliacion_issfac_fuerza: false
            }

        case GET_AFILIACION_CUMPLIMIENTO_PATRONAL:
            return {
                ...state,
                loading_afiliacion_cumplimiento_patronal: false,
                error_afiliacion_cumplimiento_patronal: null,
                success_afiliacion_cumplimiento_patronal: action.payload
            }
        case LOADING_AFILIACION_CUMPLIMIENTO_PATRONAL:
            return {
                ...state,
                loading_afiliacion_cumplimiento_patronal: true,
                error_afiliacion_cumplimiento_patronal: null,
                success_afiliacion_cumplimiento_patronal: null
            }
        case GET_ERROR_AFILIACION_CUMPLIMIENTO_PATRONAL:
            return {
                ...state,
                error_afiliacion_cumplimiento_patronal: action.payload,
                loading_afiliacion_cumplimiento_patronal: false
            }


        case GET_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF:
            return {
                ...state,
                loading_afiliacion_cumplimiento_patronal_pdf: false,
                error_afiliacion_cumplimiento_patronal_pdf: null,
                success_afiliacion_cumplimiento_patronal_pdf: action.payload
            }
        case LOADING_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF:
            return {
                ...state,
                loading_afiliacion_cumplimiento_patronal_pdf: true,
                error_afiliacion_cumplimiento_patronal_pdf: null,
                success_afiliacion_cumplimiento_patronal_pdf: null
            }
        case GET_ERROR_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF:
            return {
                ...state,
                error_afiliacion_cumplimiento_patronal_pdf: action.payload,
                loading_afiliacion_cumplimiento_patronal_pdf: false
            }


        case GET_AFILIACION_SIISPOL:
            return {
                ...state,
                loading_afiliacion_sisspol: false,
                error_afiliacion_sisspol: null,
                success_afiliacion_sisspol: action.payload
            }
        case LOADING_AFILIACION_SIISPOL:
            return {
                ...state,
                loading_afiliacion_sisspol: true,
                error_afiliacion_sisspol: null,
                success_afiliacion_sisspol: null
            }
        case GET_ERROR_AFILIACION_SIISPOL:
            return {
                ...state,
                error_afiliacion_sisspol: action.payload,
                loading_afiliacion_sisspol: false
            }


        case GET_AFILIACION_SIISPOL_PDF:
            return {
                ...state,
                loading_afiliacion_sisspol_pdf: false,
                error_afiliacion_sisspol_pdf: null,
                success_afiliacion_sisspol_pdf: action.payload
            }
        case LOADING_AFILIACION_SIISPOL_PDF:
            return {
                ...state,
                loading_afiliacion_sisspol_pdf: true,
                error_afiliacion_sisspol_pdf: null,
                success_afiliacion_sisspol_pdf: null
            }
        case GET_ERROR_AFILIACION_SIISPOL_PDF:
            return {
                ...state,
                error_afiliacion_sisspol_pdf: action.payload,
                loading_afiliacion_sisspol_pdf: false
            }

        case GET_SININIESTROS:
            return {
                ...state,
                loading_accidentRateInfo: false,
                error_accidentRateInfo: null,
                success_accidentRateInfo: action.payload
            }
        case LOADING_SININIESTROS:
            return {
                ...state,
                loading_accidentRateInfo: true,
                error_accidentRateInfo: null,
                success_accidentRateInfo: null
            }
        case GET_ERROR_SININIESTROS:
            return {
                ...state,
                error_accidentRateInfo: action.payload,
                loading_accidentRateInfo: false
            }

        case GET_SUPERINTENDENCIA_DEUDORES:
            return {
                ...state,
                loading_super_deudores: false,
                error_super_deudores: null,
                success_super_deudores: action.payload
            }
        case LOADING_SUPERINTENDENCIA_DEUDORES:
            return {
                ...state,
                loading_super_deudores: true,
                error_super_deudores: null,
                success_super_deudores: null
            }
        case GET_ERROR_SUPERINTENDENCIA_DEUDORES:
            return {
                ...state,
                error_super_deudores: action.payload,
                loading_super_deudores: false
            }

        case GET_PERSONA_EMPLEADOS:
            return {
                ...state,
                loading_persona_empleados: false,
                error_persona_empleados: null,
                success_persona_empleados: action.payload
            }
        case LOADING_PERSONA_EMPLEADOS:
            return {
                ...state,
                loading_persona_empleados: true,
                error_persona_empleados: null,
                success_persona_empleados: null
            }
        case GET_ERROR_PERSONA_EMPLEADOS:
            return {
                ...state,
                error_persona_empleados: action.payload,
                loading_persona_empleados: false
            }
        case GET_CREDITO_QUIROGRAFARIO:
            return {
                ...state,
                loading_credito_quirografario: false,
                error_credito_quirografario: null,
                success_credito_quirografario: action.payload
            }
        case LOADING_CREDITO_QUIROGRAFARIO:
            return {
                ...state,
                loading_credito_quirografario: true,
                error_credito_quirografario: null,
                success_credito_quirografario: null
            }
        case GET_ERROR_CREDITO_QUIROGRAFARIO:
            return {
                ...state,
                error_credito_quirografario: action.payload,
                loading_credito_quirografario: false
            }
        case GET_CREDITO_HIPOTECARIO:
            return {
                ...state,
                loading_credito_hipotecario: false,
                error_credito_hipotecario: null,
                success_credito_hipotecario: action.payload
            }
        case LOADING_CREDITO_HIPOTECARIO:
            return {
                ...state,
                loading_credito_hipotecario: true,
                error_credito_hipotecario: null,
                success_credito_hipotecario: null
            }
        case GET_ERROR_CREDITO_HIPOTECARIO:
            return {
                ...state,
                error_credito_hipotecario: action.payload,
                loading_credito_hipotecario: false
            }
        case GET_POLIZAS:
            return {
                ...state,
                loading_superIntendencia_polizas: false,
                error_superIntendencia_polizas: null,
                success_superIntendencia_polizas: action.payload
            }
        case LOADING_POLIZAS:
            return {
                ...state,
                loading_superIntendencia_polizas: true,
                error_superIntendencia_polizas: null,
                success_superIntendencia_polizas: null
            }
        case GET_ERROR_POLIZAS:
            return {
                ...state,
                error_superIntendencia_polizas: action.payload,
                loading_superIntendencia_polizas: false
            }
        case GET_HISTORY_MASIVE:
            return {
                ...state,
                loading_history_masive: false,
                error_superIntendencia_polizas: null,
                success_history_masive: action.payload
            }
        case LOADING_HISTORY_MASIVE:
            return {
                ...state,
                loading_history_masive: true,
                error_history_masive: null,
                success_history_masive: null
            }
        case GET_ERROR_HISTORY_MASIVE:
            return {
                ...state,
                error_history_masive: action.payload,
                loading_history_masive: false
            }

        case GET_DOCUMENT_ERROR_MASIVE:
            return {
                ...state,
                loading_error_masive: false,
                error_error_masive: null,
                success_error_masive: action.payload
            }
        case LOADING_ERROR_DOCUMENT_MASIVE:
            return {
                ...state,
                loading_error_masive: true,
                error_error_masive: null,
                success_error_masive: null
            }
        case GET_FAILED_ERROR_DOCUMENT_MASIVE:
            return {
                ...state,
                error_error_masive: action.payload,
                loading_error_masive: false
            }
        case GET_COUNT_PROCESS_MASIVE:
            return {
                ...state,
                loading_count_process_masive: false,
                error_count_process_masive: null,
                success_count_process_masive: action.payload
            }
        case LOADING_COUNT_PROCESS_MASIVE:
            return {
                ...state,
                loading_count_process_masive: true,
                error_count_process_masive: null,
                success_count_process_masive: null
            }
        case GET_ERROR_COUNT_PROCESS_MASIVE:
            return {
                ...state,
                error_count_process_masive: action.payload,
                loading_count_process_masive: false
            }
        case RESET_COUNT_PROCESS_MASIVE:
            return {
                ...state,
                loading_count_process_masive: false,
                success_count_process_masive: null,
                error_count_process_masive: null
            }
        case GET_USER_REALM:
            return {
                ...state,
                loading_user_realm: false,
                error_user_realm: null,
                success_user_realm: action.payload
            }
        case LOADING_USER_REALM:
            return {
                ...state,
                loading_user_realm: true,
                error_user_realm: null,
                success_user_realm: null
            }
        case GET_ERROR_USER_REALM:
            return {
                ...state,
                error_user_realm: action.payload,
                loading_user_realm: false
            }
        case RESET_USER_REALM:
            return {
                ...state,
                loading_user_realm: false,
                success_user_realm: null,
                error_user_realm: null
            }
        case GET_DOWNLOAD_REPORT_CONSULT:
            return {
                ...state,
                loading_download_report_consult: false,
                error_download_report_consult: null,
                success_download_report_consult: action.payload
            }
        case LOADING_DOWNLOAD_REPORT_CONSULT:
            return {
                ...state,
                loading_download_report_consult: true,
                error_download_report_consult: null,
                success_download_report_consult: null
            }
        case GET_ERROR_DOWNLOAD_REPORT_CONSULT:
            return {
                ...state,
                error_download_report_consult: action.payload,
                loading_download_report_consult: false
            }
        case RESET_DOWNLOAD_REPORT_CONSULT:
            return {
                ...state,
                loading_download_report_consult: false,
                success_download_report_consult: null,
                error_download_report_consult: null
            }
        case GET_COBERTURA_SALUD:
            return {
                ...state,
                loading_cobertura_salud: false,
                error_cobertura_salud: null,
                success_cobertura_salud: action.payload
            }
        case LOADING_COBERTURA_SALUD:
            return {
                ...state,
                loading_cobertura_salud: true,
                error_cobertura_salud: null,
                success_cobertura_salud: null
            }
        case GET_ERROR_COBERTURA_SALUD:
            return {
                ...state,
                error_cobertura_salud: action.payload,
                loading_cobertura_salud: false
            }
        case GET_RETIRED_PERSON:
            return {
                ...state,
                loading_retired_person: false,
                error_retired_person: null,
                success_retired_person: action.payload
            }
        case LOADING_RETIRED_PERSON:
            return {
                ...state,
                loading_retired_person: true,
                error_retired_person: null,
                success_retired_person: null
            }
        case GET_ERROR_RETIRED_PERSON:
            return {
                ...state,
                error_retired_person: action.payload,
                loading_retired_person: false
            }
        case GET_RETAILS_PERSON:
            return {
                ...state,
                loading_retail_person: false,
                error_retail_person: null,
                success_retail_person: action.payload
            }
        case LOADING_RETAILS_PERSON:
            return {
                ...state,
                loading_retail_person: true,
                error_retail_person: null,
                success_retail_person: null
            }
        case GET_ERROR_RETAILS_PERSON:
            return {
                ...state,
                error_retail_person: action.payload,
                loading_retail_person: false
            }
        case GET_VEHICLE_CONDITION:
            return {
                ...state,
                loading_vehicle_condition: false,
                error_vehicle_condition: null,
                success_vehicle_condition: action.payload
            }
        case LOADING_VEHICLE_CONDITION:
            return {
                ...state,
                loading_vehicle_condition: true,
                error_vehicle_condition: null,
                success_vehicle_condition: null
            }
        case GET_ERROR_VEHICLE_CONDITION:
            return {
                ...state,
                error_vehicle_condition: action.payload,
                loading_vehicle_condition: false
            }
        case GET_CUSTOMER_PAYMENT_BEHAVIOR:
            return {
                ...state,
                loading_customer_payment: false,
                error_customer_payment: null,
                success_customer_payment: action.payload
            }
        case LOADING_CUSTOMER_PAYMENT_BEHAVIOR:
            return {
                ...state,
                loading_customer_payment: true,
                error_customer_payment: null,
                success_customer_payment: null
            }
        case GET_ERROR_CUSTOMER_PAYMENT_BEHAVIOR:
            return {
                ...state,
                error_customer_payment: action.payload,
                loading_customer_payment: false
            }

        case GET_SUPA_NOVADATA:
            return {
                ...state,
                loading_supa_novadata: false,
                error_supa_novadata: null,
                success_supa_novadata: action.payload
            }
        case LOADING_SUPA_NOVADATA:
            return {
                ...state,
                loading_supa_novadata: true,
                error_supa_novadata: null,
                success_supa_novadata: null
            }
        case GET_ERROR_SUPA_NOVADATA:
            return {
                ...state,
                error_supa_novadata: action.payload,
                loading_supa_novadata: false
            }

        case GET_SRI_IMPUESTOS:
            return {
                ...state,
                loading_sri_impuestos: false,
                error_sri_impuestos: null,
                success_sri_impuestos: action.payload
            }
        case LOADING_SRI_IMPUESTOS:
            return {
                ...state,
                loading_sri_impuestos: true,
                error_sri_impuestos: null,
                success_sri_impuestos: null
            }
        case GET_ERROR_SRI_IMPUESTOS:
            return {
                ...state,
                error_sri_impuestos: action.payload,
                loading_sri_impuestos: false
            }

        case GET_IMPEDIMENTO_CARGOS:
            return {
                ...state,
                loading_impedimento_cargos: false,
                error_impedimento_cargos: null,
                success_impedimento_cargos: action.payload
            }
        case LOADING_IMPEDIMENTO_CARGOS:
            return {
                ...state,
                loading_impedimento_cargos: true,
                error_impedimento_cargos: null,
                success_impedimento_cargos: null
            }
        case GET_ERROR_IMPEDIMENTO_CARGOS:
            return {
                ...state,
                error_impedimento_cargos: action.payload,
                loading_impedimento_cargos: false
            }
        case LOADING_IMPEDIMENTO_CARGOS_PDF:
            return {...state, loading_impedimento_cargos_pdf: true}
        case GET_IMPEDIMENTO_CARGOS_PDF:
            return {...state, loading_impedimento_cargos_pdf: false}
        case GET_ERROR_IMPEDIMENTO_CARGOS_PDF:
            return {...state, loading_impedimento_cargos_pdf: false}

        case LOADING_SERCOP:
            return {...state, loading_sercop: true, error_sercop: null}
        case GET_SERCOP:
            return {...state, loading_sercop: false, success_sercop: action.payload}
        case GET_ERROR_SERCOP:
            return {...state, loading_sercop: false, error_sercop: action.payload}

        default:
            return state
    }
}
